export default "__VITE_ASSET__ClDO99Z2__"